import {action, observable, decorate} from 'mobx';
import { campaignDetailResult } from '../api/CampaignDetailApi';
import { remarkCheckResult } from '../api/RemarkCheckApi';
import { remarkPostResult } from '../api/RemarkPostApi';
import { reportResult } from '../api/ReportApi';
import { profileResult } from '../api/ProfileApi';
import { campaignUpdateResult } from '../api/CampaignUpdateApi';
import { paymentResult } from '../api/CampaignPaymentApi';
import { remarkUpdateResult } from '../api/RemarkUpdateApi';
import { bankResult } from '../api/UserBankApi';
import { transferToCustomerResult } from '../api/TransferAmountToCustomerApi';
import { payoutToCustomerResult } from '../api/PayoutAmountToCustomerApi';
import { profileImageResult } from '../api/ProfileimageApi';

class CampaignDetailStore {
	
	constructor(rootStore) {
		this.rootStore = rootStore;
	}
	
	campaign = [];
	preloader = true;
	endStory = '';
	hash = [];
	auth = JSON.parse(sessionStorage.getItem("user"));
	userId = JSON.parse(sessionStorage.getItem("userId"));
	remark = '';
	campaignId = '';
	enterRemark = '';
	loader = '';
	remarkDone = false;
	remarkDoneMsg = false;
	reportDoneMsg = false;
	campaignOwnerId = '';
	report = '';
	minimumFollower = false;
	instaFollowers = '';
	category = [];
	enableDisableCamp = false;
	suggested = [];
	applicants = [];
	listGrid = false;
	applicantPay = '';
	sortingApplicant = '';
	sortingHired = '';
	sortingSuggest = '';
	offerAmount = '';
	offerSuccess = '';
	offerDetail = [];
	offerReject = false;
	offerAccept = false;
	offerPop = '';
	hireNow = '';
	bankCheck = '';
	markDoneMsg = false;
	payoutSuccess = false;
	profileCheck = '';
	updateProfile = false;
	bankInfoCheck = false;
	bankInfoMarkCheck = false;
	hiredSuccess = false;
	errImage = false;
	files = '';
	imageLoader = false;
	
	campaignDetailFetch = (id) => {
		this.preloaderFetch(true)
		this.instaFollowersFetch('');
		campaignDetailResult(id)
			.then(res => {
				if(res.data.campaigndetails[0].hashtags){
					let hash = res.data.campaigndetails[0].hashtags.split(',');
					this.hashFetch(hash);
				}
				if(res.data.campaigndetails[0].campaignCategories){
					this.categoryFetch(res.data.campaigndetails[0].campaignCategories)
				}
				this.campaignOwnerIdFetch(res.data.campaigndetails[0].ownerId)
				this.campaignFetch(res.data.campaigndetails)
				this.endStoryFetch(res.data.campaigndetails[0].endStoryPostDate)
				if(res.data.campaigndetails[0].isDisabled === 0){
					this.campNotifyFetch(true)
				}else if(res.data.campaigndetails[0].isDisabled === 1){
					this.campNotifyFetch(false)
				}

				this.suggestedFetch(res.data.suggestedUser)
				this.applicantsFetch(res.data.remarksoncampains)

				if(this.auth){
					profileResult(this.userId)
						.then(res1 => {
							const {status,data} = res1
							let result = JSON.parse(data.message[0].profile);
							
							if(status===200 && !data.error ){
								this.instaFollowersFetch(result.followers);
								this.profileCheckFetch(result)
								this.preloaderFetch(false)
							}else{
								this.preloaderFetch(false)
							}
						}).catch(error=>console.log(error))
				}
				this.preloaderFetch(false)
			}).catch(error=>console.log(error))
	}
	remarkDoneCheckFetch = () => {
		this.preloaderFetch(true)
		let param = {where:{ownerId:this.userId,campaignId:this.campaignId}}
		remarkCheckResult(JSON.stringify(param))
			.then(res => {
				if(res.data.length !== 0){
					this.offerDetailFetch(res.data[0])
					this.remarkDoneFetch(true)
				}else{
					this.remarkDoneFetch(false)
				}
			}).catch(error=>console.log(error))
	}
	
	remarkSubmit = (event) => {
		event.preventDefault()
		this.enterRemarkFetch('')
		this.loaderFetch(true)
		let param = {where:{ownerId:this.userId,campaignId:this.campaignId}}
		let paramRemark = {
			ownerId: this.userId,
			campaignId: this.campaignId,
			remarkText: encodeURIComponent(this.remark)
		}
		
		remarkPostResult(paramRemark)
			.then(res1 => {
			remarkCheckResult(JSON.stringify(param))
				.then(res => {
				if(res.data.length !== 0){
					this.offerDetailFetch(res.data[0])
					this.remarkDoneFetch(true)
					this.remarkDoneMsgFetch(true)
					this.loaderFetch(false)
				}
			}).catch(error=>console.log(error))
				
		}).catch(error=>console.log(error))
	}
	
	markAsCompletedSubmit = (event) => {
		event.preventDefault()
		let markAsText = event.target.markas.value
		this.enterRemarkFetch('')
		this.loaderFetch(true)
		
		let param = {id:this.offerDetail.id}
		
		let paramRemark = {
			ownerId: this.userId,
			campaignId: this.campaignId,
			markAsDoneText: markAsText,
			isMarkAsDone:1
		}
		
		let param1 = {where:{ownerId:this.userId,campaignId:this.campaignId}}
		
		if(markAsText){
			remarkUpdateResult(JSON.stringify(param),paramRemark)
			.then(res1 => {
				if(res1.data.count === 1){
					remarkCheckResult(JSON.stringify(param1))
					.then(res => {
						if(res.data.length !== 0){
							this.offerDetailFetch(res.data[0])
							this.remarkDoneFetch(true)
							this.markDoneMsgFetch(true)
							this.loaderFetch(false)
							this.enterRemarkFetch('')
						}
					}).catch(error=>console.log(error))
					
				}else{
					this.enterRemarkFetch('Something went wrong. Please try again later!')
				}
			}).catch(error=>console.log(error))
		}else{
			this.enterRemarkFetch('Please enter any suggestion for campaign owner!')
			this.loaderFetch(false)
		}
	}
	
	reportSubmit = (event) => {
		event.preventDefault()

		if(this.report){
			this.loaderFetch(true)
			let paramReport = {
				reportedownerId: this.campaignOwnerId,
				campaignId: this.campaignId,
				reportText: this.report,
				ownerId: this.userId,
				reportPicUrl: this.files ? this.files : 'NA'
			}

			reportResult(paramReport)
				.then(res1 => {
					this.reportDoneMsgFetch(true)
					this.loaderFetch(false)
					this.reportFetch('')
					this.filesFetch('')
					this.enterRemarkFetch('')
				}).catch(error=>console.log(error))
		}else{
			this.enterRemarkFetch('Comment is required!')
		}
	}
	
	getFiles = (files) => {
		let size = files.size;
		let sizeSplit = size.split(" ");
		let image1 = ["image/jpg", "image/jpeg", "image/png"];
		this.imageLoaderFetch(true)
		if(image1.find(element => element === files.type)){ 
			if(sizeSplit[0] < 10 && sizeSplit[1] === 'kB'){
				
				let profileUpdate = {
					base64ImageData: files.base64,
				}
				profileImageResult(profileUpdate)
					.then(res => {
						const {status,data} = res
						if(status===200 && !data.error ){
							this.filesFetch(res.data.path)
							this.imageLoaderFetch(false)
							this.errImageFetch(false);
						}
					}).catch(error=>console.log(error))
			}else{
				this.errImageFetch(true);
				this.imageLoaderFetch(false)
			}
		}else{
			this.errImageFetch(true);
			this.imageLoaderFetch(false)
		}
	}
	
	campNotifySetting = () => {
		this.enableDisableCampFetch(true)
	}
	
	submitCampSetting = () => {
		this.loaderFetch(true)
		let checkedCamp = this.campNotify
		let inreress;
		if(this.campNotify === true){
			inreress = 1;
		}else{
			inreress = 0;
		}
		
		let campUpdate = {isDisabled:inreress}
		let param      = {id:this.campaignId}

		campaignUpdateResult(JSON.stringify(param),campUpdate)
			.then(res => {
				if(res.data.count > 0){
					campaignDetailResult(this.campaignId)
						.then(res1 => {
							if(res1.data.campaigndetails[0].isDisabled === 0){
								this.campNotifyFetch(true)
								this.enableDisableCampFetch(false)
								this.loaderFetch(false)
							}else if(res1.data.campaigndetails[0].isDisabled === 1){
								this.campNotifyFetch(false)
								this.enableDisableCampFetch(false)
								this.loaderFetch(false)
							}
					}).catch(error=>console.log(error))
				}

			}).catch(error=>console.log(error))
	}
	
	applicantFetch = (applicantId) =>{
		profileResult(applicantId)
			.then(res => {
				const {status,data} = res
				let result = JSON.parse(data.message[0].profile);
				if(status===200 && !data.error ){
					this.applicantPayFetch(result)
				}
			}).catch(error=>console.log(error))
	}
	
	submitOfferAmount = (event) => {
		event.preventDefault()
		let offerAmount = event.target.offerAmount.value
		let applicantId = event.target.applicantId.value
		this.enterRemarkFetch('')
		this.loaderFetch(true)
				
		if(offerAmount && applicantId){
			let paramRemark = {
				offerAmount: offerAmount,
				offerStatus: 1
			}
			let param = {id:applicantId}
			
			remarkUpdateResult(JSON.stringify(param),paramRemark)
				.then(res1 => {
					if(res1.data.count === 1){
						campaignDetailResult(this.campaignId)
							.then(res => {
								this.loaderFetch(false)
								this.offerSuccessFetch('Offer amount successfully submitted')
								this.offerPopFetch('')
								this.applicantsFetch(res.data.remarksoncampains)
							}).catch(error=>console.log(error))

					}else{
						this.enterRemarkFetch('Something went wrong. Please try again later!')
						this.loaderFetch(false)
					}
				}).catch(error=>console.log(error))
		}else{
			this.enterRemarkFetch('Please enter offer amount!')
			this.loaderFetch(false)
		} 
	}
	
	remarkCheckOfferFetch = (campId,ownerId) =>{
		let param1 = {where:{ownerId:ownerId,campaignId:campId}}						
		remarkCheckResult(JSON.stringify(param1))
			.then(res2 => {
				if(res2.data.length !== 0){
					this.offerAmountFetch(res2.data[0].offerAmount)
				}else{
					this.offerAmountFetch('')
				}
			}).catch(error=>console.log(error))
	}
	
	submitOfferStatus = (offerStatus) =>{
		this.loaderFetch(true)
		let paramRemark = {
			offerStatus: offerStatus
		}

		let param = {id:this.offerDetail.id}
		let param1 = {where:{ownerId:this.userId,campaignId:this.campaignId}}
			
			remarkUpdateResult(JSON.stringify(param),paramRemark)
				.then(res1 => {
				remarkCheckResult(JSON.stringify(param1))
					.then(res => {
					if(res.data.length !== 0){
						this.offerDetailFetch(res.data[0])
					}
					this.offerAcceptFetch(false)
					this.offerRejectFetch(false)
					this.loaderFetch(false)
				}).catch(error=>console.log(error))
			}).catch(error=>console.log(error))
		
	}
	
	releasePaymentSubmit = (applicantId,offerAmount) =>{
		this.loaderFetch(true)

		profileResult(applicantId)
			.then(res => {
				if(res.data.message.length > 0){
					let result = JSON.parse(res.data.message[0].profile)

					if(result.stripeAccountNumber){
						let param1 = {ownerId: applicantId,campaignId:this.campaignId,payoutAmount:offerAmount}
						transferToCustomerResult(param1)
							.then(res1 => {
								if(res1.data.error === false){
									campaignDetailResult(this.campaignId)
										.then(res => {
											this.payoutSuccessFetch(true)
											this.bankCheckFetch('')
											this.loaderFetch(false)
											this.applicantsFetch(res.data.remarksoncampains)
									}).catch(error=>console.log(error))
								}else{
									this.bankCheckFetch(res1.data.message)
									this.payoutSuccessFetch(false)
									this.loaderFetch(false)
								}
							
						}).catch(error=>console.log(error))
					}else{
						this.loaderFetch(false)
						this.payoutSuccessFetch(false)
						this.bankCheckFetch('No Bank account added for the recipient user')
					}
				}
		}).catch(error=>console.log(error))
	}
	
	hireNowSubmit = (applicantId) =>{
		this.loaderFetch(true)
		let paramRemark = {
			isHired: 1
		}
		let param = {id:applicantId}
		
		remarkUpdateResult(JSON.stringify(param),paramRemark)
			.then(res1 => {
				if(res1.data.count === 1){
					campaignDetailResult(this.campaignId)
						.then(res => {
							this.loaderFetch(false)
							this.offerPopFetch('')
							this.hiredSuccessFetch(true)
							this.applicantsFetch(res.data.remarksoncampains)
						}).catch(error=>console.log(error))

				}else{
					this.loaderFetch(false)
				}
			}).catch(error=>console.log(error))
	}
	
	campaignFetch 		 = (data) =>{this.campaign = data;}
	categoryFetch 		 = (data) =>{this.category = data;}
	preloaderFetch 		 = (data) =>{this.preloader = data;}
	endStoryFetch	 	 = (data) =>{this.endStory = data;}
	hashFetch 			 = (data) =>{this.hash = data;}
	remarkFetch 		 = (data) =>{this.remark = data;}
	campaignIdFetch 	 = (data) =>{this.campaignId = data;}
	enterRemarkFetch 	 = (data) =>{this.enterRemark = data;}
	loaderFetch 		 = (data) =>{this.loader = data;}
	remarkDoneFetch 	 = (data) =>{this.remarkDone = data;}
	remarkDoneMsgFetch 	 = (data) =>{this.remarkDoneMsg = data;}
	reportDoneMsgFetch 	 = (data) =>{this.reportDoneMsg = data;}
	campaignOwnerIdFetch = (data) =>{this.campaignOwnerId = data;}
	reportFetch 		 = (data) =>{this.report = data;}
	minimumFollowerFetch = (data) =>{this.minimumFollower = data;}
	instaFollowersFetch  = (data) =>{this.instaFollowers = data;}
	enableDisableCampFetch  = (data) => { this.enableDisableCamp = data; }
	campNotifyFetch 		= (data) => { this.campNotify = data; }
	suggestedFetch 			= (data) => { this.suggested = data; }
	applicantsFetch 		= (data) => { this.applicants = data; }
	listGridFetch 			= (data) => { this.listGrid = data; }
	applicantPayFetch 		= (data) => { this.applicantPay = data; }
	sortingApplicantFetch 	= (data) => { this.sortingApplicant = data; }
	sortingHiredFetch 		= (data) => { this.sortingHired = data; }
	sortingSuggestFetch 	= (data) => { this.sortingSuggest = data; }
	offerAmountFetch 		= (data) => { this.offerAmount = data; }
	offerSuccessFetch 		= (data) => { this.offerSuccess = data; }
	offerDetailFetch 		= (data) => { this.offerDetail = data; }
	offerAcceptFetch 		= (data) => { this.offerAccept = data; }
	offerRejectFetch 		= (data) => { this.offerReject = data; }
	offerPopFetch 			= (data) => { this.offerPop = data; }
	bankCheckFetch 			= (data) => { this.bankCheck = data; }
	markDoneMsgFetch 		= (data) => { this.markDoneMsg = data; }
	payoutSuccessFetch 		= (data) => { this.payoutSuccess = data; }
	profileCheckFetch 		= (data) => { this.profileCheck = data; }
	updateProfileFetch 		= (data) => { this.updateProfile = data; }
	bankInfoCheckFetch 		= (data) => { this.bankInfoCheck = data; }
	bankInfoMarkCheckFetch 	= (data) => { this.bankInfoMarkCheck = data; }
	hiredSuccessFetch 		= (data) => { this.hiredSuccess = data; }
	hireNowFetch 			= (data) => { this.hireNow = data; }
	errImageFetch 			= (data) => { this.errImage = data; }
	filesFetch 				= (data) => { this.files = data; }
	filesFetch 				= (data) => { this.files = data; }
	imageLoaderFetch 		= (data) => { this.imageLoader = data; }
}

decorate(CampaignDetailStore, {
	imageLoader:observable,errImage: observable,files: observable,bankInfoMarkCheck:observable,hireNow:observable,hiredSuccess:observable,bankInfoCheck:observable,updateProfile:observable,profileCheck:observable,payoutSuccess:observable,markDoneMsg:observable,bankCheck:observable,offerPop:observable,offerReject:observable,offerAccept:observable,offerSuccess:observable,offerAmount:observable,sortingSuggest:observable,sortingHired:observable,sortingApplicant:observable,applicantPay:observable,userId:observable,listGrid:observable,suggested:observable,applicants:observable,campNotify:observable,enableDisableCamp:observable,auth:observable,category:observable,campaign: observable,preloader: observable,endStory: observable,remark: observable,campaignId: observable,enterRemark: observable,loader: observable,remarkDone: observable,remarkDoneMsg: observable,reportDoneMsg: observable,campaignOwnerId:observable,report:observable,minimumFollower:observable,instaFollowers:observable,campaignFetch: action,preloaderFetch: action,endStoryFetch: action,hashFetch: action,remarkFetch: action,campaignIdFetch: action,enterRemarkFetch: action,loaderFetch: action,remarkDoneFetch: action,remarkDoneMsgFetch: action,reportDoneMsgFetch: action,campaignOwnerIdFetch:action,reportFetch:action,minimumFollowerFetch:action,instaFollowersFetch:action,categoryFetch:action,campNotifySetting:action,submitCampSetting:action,campNotifyFetch:action,enableDisableCampFetch:action,applicantsFetch:action,suggestedFetch:action,listGridFetch:action,applicantPayFetch:action,sortingApplicantFetch:action,sortingHiredFetch:action,sortingSuggestFetch:action,offerAmountFetch:action,offerSuccessFetch:action,offerDetailFetch:action,offerAcceptFetch:action,offerRejectFetch:action,submitOfferStatus:action,offerPopFetch:action,releasePaymentSubmit:action,bankCheckFetch:action,markDoneMsgFetch:action,payoutSuccessFetch:action,profileCheckFetch:action,updateProfileFetch:action,bankInfoCheckFetch:action,hireNowSubmit:action,hiredSuccessFetch:action,hireNowFetch:action,bankInfoMarkCheckFetch:action,getFiles: action,errImageFetch: action,filesFetch: action,imageLoaderFetch:action
});

export default CampaignDetailStore;